module.exports = __webpack_public_path__ + "static/img/groupBg.94da8065.png";